import update from "immutability-helper";
export const moveElementInArray = ({ array, fromIndex, toIndex }) => {
  const item = array[fromIndex];
  let updatedArray = update(array, { $splice: [[fromIndex, 1]] });
  updatedArray = update(updatedArray, { $splice: [[toIndex, 0, item]] });
  return updatedArray;
};
